import { defaultTheme } from '@shared/lib/theme'

export type IconButtonColorType = Exclude<
  keyof typeof defaultTheme.colors.background,
  'modal' | 'hover' | 'header' | 'gradientAccent' | 'gradientSecondary'
>

export const iconButtonIconColorByColor = (color: IconButtonColorType) =>
  color === 'inverted' ? 'inverted' : 'primary'

export const iconButtonSizesRem = {
  '24': '1.5rem',
  '32': '2rem',
  '44': '2.75rem',
  '52': '3.25rem',
  '64': '4rem',
  '72': '4.5rem',
}

export const iconButtonPaddingsRem = {
  '24': '0.25rem',
  '32': '0.5rem',
  '44': '0.625rem',
  '52': '0.875rem',
  '64': '1.25rem',
  '72': '1.5rem',
}

export const iconButtonBorderRadiusesRem = {
  '24': '0.5rem',
  '32': '0.75rem',
  '44': '1rem',
  '52': '1rem',
  '64': '1rem',
  '72': '1.25rem',
}

export const iconButtonIconSizesRem = {
  '24': '0.625rem',
  '32': '0.625rem',
  '44': '1rem',
  '52': '1rem',
  '64': '1rem',
  '72': '1rem',
}

export const iconButtonSpinnerSizesRem = {
  '24': '0.75rem',
  '32': '0.75rem',
  '44': '1rem',
  '52': '1rem',
  '64': '1rem',
  '72': '1.25rem',
}
